import { FontIcon, Icon } from "@fluentui/react";
import { getFileTypeIconProps } from "@fluentui/react-file-type-icons";
import { Progress } from "antd";
import { useSelector } from "react-redux";

// import "../FileBrowserComponent.css";
import { RootState } from "../../../redux/Store";
import { deleteDocument } from "../../../redux/EngageTranslation/EngageTranslationAction";
import { useAppDispatch } from "../../../redux/useAppDispatch";

function FileUploadProgressContainer(props: any) {
  const fileUploadArray = useSelector((state: RootState) => state.engageTranslationState.engageTranslateMainState.fileUploadArrayObject);
  const uploadedID = useSelector((state: RootState) => state.engageTranslationState.engageTranslateMainState.uploadedID);
  const dispatch = useAppDispatch();

  return (
    <div className="additional-container filter-container gap-4 d-flex flex-column col-lg-2 col-12 border-start ">
      <div className="title d-flex align-items-center justify-content-between border-bottom">
        <div className="d-flex align-items-center gap-2 ">
          <b>Progress</b>
        </div>
        <div className="d-flex gap-3">
          <FontIcon
            iconName="Cancel"
            className="close-icon"
            onClick={() => props.close()}
          />
        </div>
      </div>
      {Object.keys(fileUploadArray).map((key) => {
        return (
          <div
            className="d-flex flex-row gap-3 p-3"
            key={key}>
            <Icon {...getFileTypeIconProps({ extension: fileUploadArray[key].fileExtension, size: 40, imageFileType: "svg" })} />
            <div className="w-100">
              <span style={{ fontSize: 12 }}>
                Uploading <span style={{ fontWeight: 700, fontSize: 12 }}>{fileUploadArray[key].fileName} to</span>
              </span>
              <Progress
                percent={fileUploadArray[key].uploadProgress}
                status={fileUploadArray[key].status}
              />
            </div>
            <FontIcon
              iconName="Cancel"
              className="close-icon"
              onClick={() => {
                fileUploadArray[key].cancelUploadToken?.cancel();
              }}
            />
          </div>
        );
      })}
    </div>
  );
}
//transform this file.type to file extension

export default FileUploadProgressContainer;
